import styled from 'styled-components';

const ICON_PROPERTIES = {
  WIDTH: 22
};

export const IconContainer = styled.div`
  height: 40px;
  margin: 0;
  color: #333333;
  font-size: 16px;
  padding: 8px;
  text-align: center;
  line-height: 1.4;
  position: absolute;
`;

export const Container = styled.div`
  height: 39px;
  position: relative;
  border: ${({ theme }) => theme.colors.accentGray03};
  input {
    border: 1px solid ${({ theme }) => theme.colors.accentGray03};
    outline: none;
    padding: 8px;
  }

  .icon.right {
    right: 0;
  }

  .icon.left + input {
    padding-left: ${ICON_PROPERTIES.WIDTH + 8}px;
    text-align: left;
  }

  .icon.right + input {
    padding-right: ${ICON_PROPERTIES.WIDTH + 8}px;
  }

  &.inline {
    display: inline-block;
  }
`;
